export default {
  parameters: {
    landing_id: "PlAbFC",
  },
  newDesign: true,
  title: "Coding FreeCourse | Poland",
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    startBackground: "white",
    quizBackground: "#white",
    title:
      "Odpowiedz na tylko 4 pytania i weź udział w BEZPŁATNYM KURSIE",
    subtitle:
      "Zajęcia są prowadzone w języku polskim! Twoje dziecko stworzy własny projekt. Zamiast grać gry będzie je z nami tworzyć.",
    image: {
      url: "/welcome/freec_poland_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/freec_poland_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Ruszajmy 🚀 ",
  },
  // successPage: {
  //   title: "¡Felicitaciones! 🎁",
  //   subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
  //   button: "📆 Reservar una clase",
  // },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Dziękujemy za zaufanie naszej platformie edukacyjnej!",
    subtitle:
      "Niestety, tablety lub telefony nie nadają się do korzystania z naszych lekcji. Będziemy szczęśliwi, widząc Was na naszych zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      question: "Ile czasu dziennie Twoje dziecko spędza używając gadżetów?",
      answers: [
        "Do 2 godzin 😍",
        "Od 2 do 4 godzin 🙂",
        "Więcej niż 4 godziny ☹️",
        "Nie pilnuję tego 🤔",
      ],
    },
    2: {
      question: "Jaki charakter ma Twoje dziecko?",
      subtitle: "To pomoże nam odpowiednio dobrać wykwalifikowanego nauczyciela pod charakter Twojego dziecka",
      answers: [
        "Aktywne, bardzo rozmowne 🥳",
        "Nieśmiałe, często się wstydzi 🫢",
        "Marzycielskie, oddaje się marzeniom 🥰",
        "Ciche, spędza czas 'w sobie' 🤫",
        "Nie wie czego chce 🤔",
        "Własna wersja, opowiem na lekcji 🙋‍♀️"
      ],
    },
    3: {
      question: "Na czym zależy Ci najbardziej?",
      answers: [
        "Nawiązanie kontaktu z dzieckiem 👶",
        "Natychmiastowe rezultaty 🎣",
        "Zainteresowanie i motywacja dziecka 🧠",
        "Przydatne umiejętności w przyszłości 👏",
        "Przyjazna atmosfera 😻",
        "Wygodna platforma edukacyjna 🖥️"
      ],
    },
    4: {
      question: "Jak oceniasz poziom motywacji Twojego dziecka?",
      answers: [
        "Niski 😞",
        "Średni 🤔",
        "Wysoki 😍",
      ],
    },
    5: {
      title: "Ile lat ma Twoje dziecko?",
      type: "age",
      button: "",
    },
    6: {
      question:
        "Czy masz komputer/laptop?",
      answers: [
        "Tak ✔️",
        {
          answer: "Nie ❌",
          stopAnswer: true,
        },
      ],
    },
    7: {
      title: "Gratulacje!",
      typeInfo: "congrats",
      subtitle:
        "Kliknij '📅 Zarezerwuj zajęcia', aby dokończyć rejestrację.",
      button: "📅 Zarezerwuj zajęcia",
    },
    8: {
      title: "Zarezerwuj zajęcia",
      type: "one-page-contacts",
      subtitle: "",
      button: "👏 Świetnie. Ostatni krok!",
    },
    9: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    10: {
      title:
        "Przejrzyj te informacje, aby zakończyć rejestrację ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Pamiętaj, że do lekcji będziesz potrzebować działającego komputera stacjonarnego lub laptopa i musisz towarzyszyć swojemu dziecku przez cały czas trwania zajęć. Pamiętaj, że zajęcia są indywidualne i spersonalizowane.",
      button: "Co jeszcze?",
    },
    11: {
      title: "Przed zajęciami próbnymi sprawdź swoją skrzynkę e-mail i WhatsApp 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Na 24 godziny przed zajęciami wyślemy przypomnienie, a na 2 godziny przed zajęciami poprosimy o potwierdzenie obecności. Bardzo ważne jest, abyśmy pozostali w kontakcie, aby zajęcia nie zostały odwołane.",
      button: "Co jeszcze?",
    },
    12: {
      title: "Lekcja odbędzie się na naszej platformie 💻",
      typeInfo: "classroom",
      subtitle:
        "Otrzymasz link i unikalny kod przez WhatsApp oraz e-mail. Wystarczy kliknąć w link, a przeniesie Cię on prosto do lekcji. Bez dodatkowych aplikacji, bez pobierania.",
      button: "Rozumiem ✅",
    }
  },
};
